import { CreditCard, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { fmtUSD } from "@/lib/money";

const QUICK_AMOUNTS = [5, 10, 25, 50, 100];

export const PurchaseCard = ({ amount, setAmount, amountNum, amountValid, starting, onCheckout }) => (
  <div className="border border-border bg-[#0A0A0A] rounded-sm p-6 space-y-4">
    <div className="flex items-center gap-2">
      <CreditCard className="w-4 h-4 text-[#007AFF]" />
      <h2 className="font-heading text-lg font-black tracking-tight">Purchase new credits</h2>
    </div>
    <div className="flex flex-wrap gap-2">
      {QUICK_AMOUNTS.map((q) => (
        <button key={q} onClick={() => setAmount(String(q))} data-testid={`quick-amount-${q}`}
          className={`px-4 py-2 rounded-sm border text-sm font-mono transition-colors duration-200 ${
            parseFloat(amount) === q
              ? "border-[#007AFF] bg-[#007AFF]/10 text-[#007AFF]"
              : "border-border text-muted-foreground hover:text-white hover:border-white"
          }`}>
          ${q}
        </button>
      ))}
    </div>
    <div>
      <Label className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Dollar amount</Label>
      <div className="relative mt-2">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground font-mono">$</span>
        <Input type="number" min="5" max="500" step="0.01" value={amount}
          onChange={(e) => setAmount(e.target.value)} data-testid="credit-amount-input"
          className="pl-7 bg-background border-border rounded-sm font-mono focus-visible:ring-[#007AFF]" />
      </div>
      <p className={`text-xs mt-1.5 ${amountValid ? "text-muted-foreground" : "text-red-400"}`} data-testid="amount-limits-hint">
        Minimum $5.00 — maximum $500.00 per purchase.
      </p>
    </div>
    <Button onClick={onCheckout} disabled={starting || !amountValid} data-testid="checkout-btn"
      className="w-full bg-[#007AFF] hover:bg-[#0066d6] text-white rounded-sm gap-2 font-semibold">
      {starting ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />}
      {starting ? "Redirecting to Stripe…" : `Buy ${amountValid ? fmtUSD(amountNum) : ""} in credits`}
    </Button>
    <p className="text-[11px] text-muted-foreground">
      Secure checkout by Stripe. Your card is saved securely by Stripe so auto-refill can work — we never see your card number.
    </p>
  </div>
);
